'use strict';

define('features/slp/thank-you',[
  'jquery',
  'txt!./thank-you.hbs',
  'features/recentVehicles',
  'lib/page-cache',
  'lib/services/batws',
  'lib/util/tda.config',
  'webStorage',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/analytics/blocks/index',
  'features/ctas/index',
  'lib/getParameterByName',
  'lib/transforms/dealer.tmpl.common',

  // side effect includes
  'Handlebars',
  'lib/helpers/ifCond',
  'lib/loader/series',
  'lib/transforms/series.mapByCode'
], function (
  $,
  txtTemplate,
  recentVehicles,
  PageCache,
  batws,
  tdaConfig,
  ws,
  anPageLoad,
  anClicks,
  anAddContext,
  blocks,
  ctas,
  getParameterByName,
  xformDealersCommon
) {
  var __tmplConfirmation = Handlebars.compile(txtTemplate);
  var __series = recentVehicles.getMostRecentVehicle();

  var SLPConfirmation = function (el, config) {
    this.$el = $(el);
    this.config = $.extend({}, SLPConfirmation.defaults, config);
  };

  SLPConfirmation.defaults = {};

  $.extend(SLPConfirmation.prototype, {
    load: function () {
      var self = this;
      var selVeh = __series && window.location.search.indexOf('noseries') === -1 ? __series : null;
      var dealer = getParameterByName('dealercode');
      var cacheIdsArr = ['series.map', 'dealer.' + dealer];

      PageCache.set('dealer.' + dealer, batws.geo().dealerDetails({ dealerCode: dealer }));

      // When our recent vehicle has a trimCode
      // we need to getSeriesTrimInfo in order to output the trim name in the DOM. Yaaaay.
      if (selVeh && selVeh.trimCode) {
        var cacheIdSeries = selVeh.series;
        cacheIdsArr.push(cacheIdSeries);
        if (!PageCache.hasOrPending(cacheIdSeries)) {
          PageCache.maybeSet(cacheIdSeries, batws.cls().getSeriesTrimInfo({
            series_code: selVeh.series,
            year: selVeh.year
          }));
        }
      }

      PageCache.awaitAll(cacheIdsArr)
        .then(function (res) {
          var seriesMap = res[0];
          var seriesTrims;
          self.dealer = xformDealersCommon(res[1].dealerLocator);
          if (res[2]) {
            seriesTrims = res[2].series.trims;
          }
          if (selVeh && selVeh.series) {
            self.vehicle = self.decorateVehicle(seriesMap, selVeh, seriesTrims);
          } else {
            self.vehicle = null;
          }
          self.drawPage();
          self.analyticsLoad();
        })
        .catch(function (err) { console.log('Err: ', err); }); // eslint-disable-line no-console
    },

    decorateVehicle: function decorateVehicle(seriesMap, selVeh, seriesTrims) {
      var foundTrim;
      if (seriesTrims) {
        foundTrim = seriesTrims.find(function (trim) {
          return trim.trim_id == selVeh.trimCode;
        });
      }

      return {
        series: selVeh.series,
        year: selVeh.year,
        display_name: seriesMap[selVeh.series].series_display_name,
        trimDisplay: foundTrim ? '<li>' + foundTrim.trim_name + '</li>' : '',
        dataLayer: {
          series_code: selVeh.series,
          series_year: selVeh.year,
          series_number: selVeh.trimCode || '',
          series_msrp: foundTrim ? foundTrim.msrp : '',
          series_grade: selVeh.trim || ''
        }
      };
    },

    drawPage: function drawPage() {
      var ctx = {
        i18n: this.config.i18n,
        vehicle: this.vehicle,
        hrefRoot: tdaConfig.site.context_url,
        hideTradeIn: tdaConfig.tda.code === 'WWW',
        fName: ws.getSessionStorage().getItem('customerFirstName')
      };
      console.log('CTX for SLPConfirmation: ', ctx); // eslint-disable-line no-console
      this.$el.html(__tmplConfirmation(ctx));
      ctas.offers(this.vehicle.series, this.$el);
    },

    // Right now, the drawing of the dealer panel is handled in dealer-panel-component
    // we get the dealer here, for now, for analytics purposes only.
    // TODO: refactor dealer-panel
    analyticsLoad: function () {
      var $scope = $('div[data-component-name="Confirmation"]');
      anAddContext($scope, blocks.dealerBlock(this.dealer[0]));
      if (this.vehicle) {
        anAddContext($scope, blocks.seriesBlock(this.vehicle));
      }
      anPageLoad($scope, blocks.keyMetrics(this.config.keyMetric));
      anClicks($scope);
    }
  });

  return SLPConfirmation;
});

